import getQuery from '../../utilities/query';

import { handleError } from '../../utilities/errorHandling';
import { loans } from '../../api';

const queryClient = getQuery();

export const LOANS_ALL = 'loans.all';
export const LOAN_DETAILS = 'loan.details';

queryClient.setQueryDefaults(LOANS_ALL, {
  queryFn: async () => {
    const { data } = await loans.all();
    return data;
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(LOAN_DETAILS, {
  queryFn: async ({ queryKey }) => {
    const { data } = await loans.loanDetails(queryKey[1]);
    return data;
  },
  onError: (error) => {
    handleError(error);
  },
});
